import { IntroItem } from "@/types/generated/DifcamWebTypes";

import { BaseService } from "./BaseService";

export class IntroService extends BaseService {
  loadIntroItems(): Promise<IntroItem[]> {
    return this.get<IntroItem[]>(`/intro`);
  }
}
